import { ReactNode, Suspense } from "react";
import type { DatePickerProps } from "react-datepicker";

import { ChunkLoadErrorBoundary, lazyChunk } from "@shared/ChunkLoadErrorBoundary";

const LazyDatePicker = lazyChunk(() => import("./DatePicker"));

type Props = DatePickerProps & {
    loadingFallback: ReactNode;
    errorFallback: ReactNode;
};

export const DatePicker = ({ loadingFallback, errorFallback, ...props }: Props) => (
    <ChunkLoadErrorBoundary fallback={errorFallback}>
        <Suspense fallback={loadingFallback}>
            <LazyDatePicker {...(props as DatePickerProps)} />
        </Suspense>
    </ChunkLoadErrorBoundary>
);
